var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLTag",class:_vm.classes},[_c('div',{staticClass:"LLTag__caption"},[_vm._t("default")],2),(_vm.withRemove)?_c('div',{staticClass:"LLTag__clear",on:{"click":_vm.remove}},[_c('ClearIcon',{staticClass:"LLTag__clear-icon"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }